const stats = [
  { value: "12", label: "Enterprise Clients" },
  { value: "4,000+", label: "Learners Deployed" },
  { value: "25+", label: "Academic Institutions" },
];

export const Stats = () => (
  <section data-testid="stats-section" className="border-y border-ink">
    <div className="container-wide">
      <div className="py-10 md:py-14 flex items-baseline justify-between gap-6 flex-wrap">
        <p className="font-mono-cust text-[11px] uppercase tracking-[0.3em] text-gray-500">
          / 01 — Numbers that speak
        </p>
        <p className="text-sm text-ink-muted max-w-md">
          Our track record demonstrates a commitment to delivering measurable outcomes — not just deliverables.
        </p>
      </div>
    </div>
    <div className="grid grid-cols-1 md:grid-cols-3 border-t border-ink divide-x divide-y md:divide-y-0 divide-black/10">
      {stats.map((s, i) => (
        <div
          key={s.label}
          data-testid={`stat-${i}`}
          className="p-8 md:p-12 lg:p-16 hover:bg-[#F3F3F1] transition-colors duration-500 group"
        >
          <p className="font-heading text-5xl md:text-6xl lg:text-7xl tracking-tighter text-[#9F381A] leading-none mb-4 group-hover:translate-x-1 transition-transform">
            {s.value}
          </p>
          <p className="text-[11px] md:text-xs uppercase tracking-[0.25em] text-gray-500">{s.label}</p>
        </div>
      ))}
    </div>
  </section>
);

export default Stats;
